import React, { useEffect, useState } from "react"
import { useDividas } from "../../../../../../../context/DividasContext"
import { Emails, Telefones } from "../../../../../../../types/devedor-interface"
import { CanalEnvio, usePropostas } from "../../../../../../../context/PropostasContext"

export const CanaisEnvio = () => {
  const { devedorCadastro } = useDividas()
  const { getCanalEnvio } = usePropostas()
  const [canalEnvio, setCanalEnvio] = useState<CanalEnvio>({
    canalrecebimento: 'email',
    destinorecebimento: ''
  })
  const [email, setEmail] = useState('')
  const [sms, setSMS] = useState('')

  const listaSMS = devedorCadastro?.telefones?.telefonecliente && devedorCadastro?.telefones?.telefonecliente.length > 0 ? devedorCadastro?.telefones.telefonecliente.filter(item => (item.tipo_telefone.includes('Movel') && (item.situacaotelefone === 'Valido' || item.situacaotelefone === 'Contactado'))) : [] as Telefones[]
  const listaEmails = devedorCadastro?.emails?.emailcliente && devedorCadastro?.emails?.emailcliente?.length > 0 ? devedorCadastro?.emails.emailcliente.filter(item => item.situacaoemail.toLocaleUpperCase() === 'VALIDO') : [] as Emails[]

  const radiosCss = 'flex items-center gap-1'

  function formatarTelefone(telefone: string) {
    telefone = telefone?.replace(/\D/g, '');
    telefone = telefone?.replace(/^(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3');
    return telefone;
  }

  useEffect(() => {
    if (listaEmails?.length > 0) {
      setCanalEnvio({
        canalrecebimento: 'email',
        destinorecebimento: listaEmails[0].email
      })
      getCanalEnvio({
        canalrecebimento: 'email',
        destinorecebimento: listaEmails[0].email
      })
      setEmail(listaEmails[0]?.email)
    }
  }, [])



  useEffect(() => {
    getCanalEnvio(canalEnvio)
  }, [canalEnvio])

  function handelEmailSMS(value: string, nome: string) {
    if (nome === 'email') {
      setEmail(value)
      setCanalEnvio(prevState => ({
        ...prevState,
        'destinorecebimento': `${value};${sms}`,
      }))
    } else {
      setSMS(value)
      setCanalEnvio(prevState => ({
        ...prevState,
        'destinorecebimento': `${email};${value}`,
      }))


    }
    getCanalEnvio(canalEnvio)
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = event.target;
    let nome = name === 'canal' ? 'canalrecebimento' : 'destinorecebimento'

    if (value === 'sms' && listaSMS && listaSMS.length === 1) {
      setCanalEnvio({ destinorecebimento: listaSMS[0].telefone, canalrecebimento: 'sms' });
    } else {
      setCanalEnvio(prevState => ({
        ...prevState,
        [nome]: value,
      }));
    }
    getCanalEnvio(canalEnvio)
  };

  return (
    <div className="flex flex-col text-sm border rounded-md p-2 border-gray-700 mb-4 text-gray-800">
      <strong className="font-medium">Para quais canais deseja enviar?</strong>

      <div className="flex items-center gap-6 my-2 text-xs">
        <div className={radiosCss}>
          <input onChange={(e) => handleChange(e)} type="radio" name="canal" id={'email'} value={'email'} defaultChecked />
          <label htmlFor="email">Somente para o email</label>
        </div>
        <div className={radiosCss}>
          <input onChange={(e) => handleChange(e)} type="radio" name="canal" id={'sms'} value={'sms'} />
          <label htmlFor="sms">Somente para SMS</label>
        </div>
        <div className={radiosCss}>
          <input onChange={(e) => handleChange(e)} type="radio" name="canal" id={'email;sms'} value={'email;sms'} disabled={listaEmails.length === 0 || listaSMS.length === 0} />
          <label htmlFor="email;sms">Email e SMS</label>
        </div>
        <div className={radiosCss}>
          <input onChange={(e) => handleChange(e)} type="radio" name="canal" id={'whatsapp'} value={'whatsapp'} disabled />
          <label htmlFor="whatsapp">Somente para WhatsApp</label>
        </div>
        <div className={radiosCss}>
          <input onChange={(e) => handleChange(e)} type="radio" name="canal" id={'email;sms;whatsapp'} value={'email;sms;whatsapp'} disabled />
          <label htmlFor="email;sms;whatsapp">Email, SMS e WhatsApp</label>
        </div>
      </div>



      <div className="flex items-start justify-between gap-4 w-full my-2">
        {
          (canalEnvio.canalrecebimento === 'email' || canalEnvio.canalrecebimento === 'email;sms') && (
            <div className="border rounded-md p-2 border-primary min-w-[48%]">
              <p>Escolha o e-mail:</p>

              {
                listaEmails && listaEmails?.length > 0 ? listaEmails?.map(email => (
                  <div className={`${radiosCss} my-1`} key={email.id_email}>
                    <input onChange={(e) => canalEnvio.canalrecebimento === 'email;sms' ? handelEmailSMS(e.target.value, 'email') : handleChange(e)} type="radio" name="email" id={email.id_email} value={email.email} defaultChecked={listaEmails.length === 1} />
                    <label htmlFor={email.id_email}>{email.email}</label>
                  </div>
                )) : (
                  <p>Não há emails cadastrados!</p>
                )
              }

            </div>

          )
        }

        {
          (canalEnvio.canalrecebimento === 'sms' || canalEnvio.canalrecebimento === 'email;sms') && (
            <div className="border rounded-md p-2 border-primary min-w-[48%]">
              <p>Escolha o SMS:</p>
              {
                listaSMS && listaSMS?.length > 0 ? listaSMS?.map(tel => (
                  <div className={`${radiosCss} my-1`} key={tel.id_telefone}>
                    <input onChange={(e) => canalEnvio.canalrecebimento === 'email;sms' ? handelEmailSMS(e.target.value, 'sms') : handleChange(e)} type="radio" name="sms" id={tel.id_telefone} value={tel.telefone} defaultChecked={listaSMS.length === 1} />
                    <label htmlFor={tel.id_telefone}>{formatarTelefone(tel.telefone)}</label>
                  </div>
                )) : (
                  <p>Não há telefones móveis cadastrados!</p>
                )
              }
            </div>

          )
        }
      </div>
    </div>
  )
}